module.exports = __webpack_public_path__ + "img/cinamon.9088a344.jpg";